import React, { useContext } from "react";
import { Card, Container } from "react-bootstrap";

import { useMediaQuery } from "react-responsive";
import AppContext from "../../context/AppContext";

const CategoryCard = ({ item }) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const { baseUrl } = useContext(AppContext);

  return (
    <Card className="p-3 m-2 serviceRepair shadow-sm">
      <Container className="circle">
        <img
          src={`${baseUrl}/storage/${item.image}`}
          className="img img-fluid"
        />
      </Container>
      <Card.Body className="p-0 mt-3">
        <Card.Title
          className="poppins-semiBold text-center"
          style={{ fontSize: 14 }}
        >
          {item.name}
        </Card.Title>
      </Card.Body>
    </Card>
  );
};

export default CategoryCard;
